import React from 'react';
import { Link } from 'react-router-dom';
import GamesPage from './GamesPage';
import './PublicPlayPage.css';

/**
 * Public, no-login arcade — the landing a NON-member hits when they open a
 * challenge link (e.g. /play?challenge=…). It renders the full arcade in guest
 * mode inside a minimal standalone shell with a sign-up call-to-action, so a
 * peer can try to beat the challenge before they ever create an account.
 */
const PublicPlayPage: React.FC = () => {
  return (
    <div className="public-play">
      <header className="pp-header">
        <Link to="/" className="pp-logo">Ak<span>ountant</span></Link>
        <div className="pp-header-right">
          <span className="pp-tagline">The Arcade — no login needed</span>
          <Link to="/auth" className="pp-signup">Sign up free</Link>
        </div>
      </header>
      <main className="pp-main">
        <GamesPage guestMode />
      </main>
      <footer className="pp-footer">
        Akountant — your business platform with a coffee-break arcade. <Link to="/">Learn more</Link>
      </footer>
    </div>
  );
};

export default PublicPlayPage;
